export const elements = {
  navigation: {
    mobileHeight: "50px",
    desktopHeight: "60px",
    mobilePanelFooterHeight: "50px",
  },
  breadcrumb: {
    desktopHeight: "26px",
  },
  banner: {
    height: "27px",
  },
} as const
